import React, { useState } from 'react';
import styled from '@emotion/styled';
import ApplicationModel from '../../../../../shared/models/applications/api/ApplicationModel';
import ScrollablePanelBody from '../../../../../shared/components/structure/ScrollablePanelBody';
import DentalPatientLists from './DentalPatientLists';
import ScheduledCalls from './ScheduledCalls';

interface Props { application: ApplicationModel; history: any; }

export default function OutboundCall(props: Props) {
    const [activeView, setActiveView] = useState<'lists' | 'calls'>('lists');
    // Set when an upload's confirmation opens Scheduled calls & history on that upload; cleared by switching tabs.
    const [openBatch, setOpenBatch] = useState<{ id: string; name: string; firstDate?: string; lastDate?: string }>();
    const show = (view: 'lists' | 'calls') => { setOpenBatch(undefined); setActiveView(view); };
    const organizationString = localStorage.getItem('CURRENT_ORG');
    const org = organizationString ? JSON.parse(organizationString) : null;
    return <ScrollablePanelBody>
        <ViewTabs role="tablist" aria-label="Outbound call workspace" onKeyDown={event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const view = event.key === 'Home' ? 'lists' : event.key === 'End' ? 'calls' : activeView === 'lists' ? 'calls' : 'lists';
            show(view);
            event.currentTarget.querySelector<HTMLButtonElement>(view === 'lists' ? '#patient-lists-tab' : '#scheduled-calls-tab')?.focus();
        }}>
            <button id="patient-lists-tab" role="tab" aria-controls="patient-lists-panel" aria-selected={activeView === 'lists'} tabIndex={activeView === 'lists' ? 0 : -1} onClick={() => show('lists')}>Patient lists</button>
            <button id="scheduled-calls-tab" role="tab" aria-controls="scheduled-calls-panel" aria-selected={activeView === 'calls'} tabIndex={activeView === 'calls' ? 0 : -1} onClick={() => show('calls')}>Scheduled calls & history</button>
        </ViewTabs>
        <div id="patient-lists-panel" role="tabpanel" aria-labelledby="patient-lists-tab" hidden={activeView !== 'lists'}>
            <DentalPatientLists key={props.application.id} applicationId={props.application.id} organizationId={org?.id} onViewScheduledCalls={(id, name, firstDate, lastDate) => {
                setOpenBatch({ id, name, firstDate, lastDate });
                setActiveView('calls');
                requestAnimationFrame(() => document.getElementById('scheduled-calls-tab')?.focus());
            }} />
        </div>
        <div id="scheduled-calls-panel" role="tabpanel" aria-labelledby="scheduled-calls-tab" hidden={activeView !== 'calls'}>
            {activeView === 'calls' && <ScheduledCalls key={`${props.application.id}:${openBatch?.id || ''}`} organizationId={org?.id} applicationId={props.application.id} officeTimeZone={props.application.timeZone} onUpload={() => show('lists')} initialBatch={openBatch} />}
        </div>
    </ScrollablePanelBody>;
}

const ViewTabs = styled.div`
    display: flex;
    gap: 24px;
    padding: 8px 28px 0;
    border-bottom: 1px solid #dfe5ed;
    button {
        padding: 14px 0;
        border: 0;
        border-bottom: 3px solid transparent;
        background: transparent;
        color: #64748b;
        font: inherit;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
    }
    button[aria-selected=true] { color: #1e7eb9; border-bottom-color: #1e7eb9; }
    button:focus-visible { outline: 3px solid #6eb3db; outline-offset: 2px; }
`;
